<script>
import ModalComponent from "@/components/Modal.vue";
import FormReviews from "@/components/reviews/product/FormReviews.vue";

export default {
  name: 'ModalReview',
  components: {FormReviews, ModalComponent},
  props: {
    product: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <modal-component title="Avis">
    <template #header>
      <div>
        <h3 class="mb-1 text-lg font-semibold text-gray-900">Ajouter un avis pour:</h3>
        <router-link to="#" class="font-medium text-primary-700 hover:underline">
          {{ product.title }} - {{ product.category.Label }}
        </router-link>
      </div>
    </template>
    <template #body>
      <form-reviews :product-id="product.id"  @close-modal="$emit('closeModal')"/>
    </template>
  </modal-component>
</template>
